module.exports = __webpack_public_path__ + "static/media/calendar.44913c66.png";